module.exports = __webpack_public_path__ + "media/src/images/icons/generic-file-606a955d9d4e15f776e202d790fee703.svg";